// directives/draggable.js
export default {
  bind(el, binding) {
    const enable = binding.value !== undefined && binding.value !== null && binding.value !== '';
    el.setAttribute('draggable', !!enable);
    if (!enable) return;
    el._dragStart = (event) => {
      el.classList.add('ugo-draggable');
      event.dataTransfer.setData('text', String(binding.value));
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.dropEffect = 'move';
    };
    el._dragEnd = () => {
      el.classList.remove('ugo-draggable');
    };
    el.addEventListener('dragstart', el._dragStart);
    el.addEventListener('dragend', el._dragEnd);
  },
  update(el, binding) {
    const enable = binding.value !== undefined && binding.value !== null && binding.value !== '';
    el.setAttribute('draggable', !!enable);
  },
  unbind(el) {
    if (el._dragStart) {
      el.removeEventListener('dragstart', el._dragStart);
      el.removeEventListener('dragend', el._dragEnd);
    }
  },
};

